import { type ReactNode, type FC } from 'react';

interface SummaryTableProps {
  footerMessage?: string;
  children: ReactNode;
  changingPlan: boolean;
}

const SummaryTable: FC<SummaryTableProps> = ({ children, footerMessage, changingPlan }) => (
  <table className="SummaryTable">
    <thead>
      <tr className="SummaryTable__row--header">
        <th className="SummaryTable__cell--header SummaryTable__cell--header-desc">Description</th>
        <th className="SummaryTable__cell--header">Quantity</th>
        <th className="SummaryTable__cell--header">30-day recurring charge</th>
        {changingPlan && <th className="SummaryTable__cell--header">Pro-rated 30-day charge</th>}
        <th className="SummaryTable__cell--header SummaryTable__cell--total">
          {changingPlan ? 'Pro-rated total' : 'Total'}
        </th>
      </tr>
    </thead>
    <tbody>
      {children}
      {footerMessage && (
        <tr>
          <td
            colSpan={changingPlan ? 5 : 4}
            className="SummaryTable__cell SummaryTable__cell--footer"
          >
            {footerMessage}
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

export default SummaryTable;
